import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import CheckCircleFilled from '@icon/CheckCircleFilled';
import CircularProgress from '@base/CircularProgress/CircularProgress';
import { Spacings } from '@styles/index';

const CourseProgress = styled(CircularProgress)`
  grid-row: span 2;
  align-self: center;
  margin-right: ${Spacings.SPACING_1B};
`;

const CheckboxFilled = styled(CheckCircleFilled)`
  grid-row: span 2;
  align-self: center;
`;

const TopicProgress = ({ topic }) => {
  if (topic.progress > 0) {
    if (topic.progress === 100) {
      return (
        <CheckboxFilled
          size={Spacings.SPACING_6B}
          color="var(--color-i-green)"
        />
      );
    }
    return (
      <CourseProgress
        size={25}
        thickness={5}
        value={topic.progress}
        unfilledColor="var(--color-divider)"
      />
    );
  }
  return null;
};

TopicProgress.propTypes = {
  topic: PropTypes.objectOf(PropTypes.any).isRequired
};

export default TopicProgress;
